import axios, { AxiosInstance } from "axios";
import { getCookie } from "../cookie-helper/cookieHelper";
let token = getCookie("token") as string;

const axiosInstance: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_GATEWAY,
  maxRedirects: 5,
  headers: {
    token: token,
    "Content-Type": "*",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Credentials": "true",
  },
});

export default axiosInstance;
